import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class appHeaderPromo_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `

            <header class="default-header" id="default-header">
                <div class="default-header-inner">
                    <div  class="default-header-left">
                        <button class=" icon i-hamburger" id="burger-menu-button" data-bind="event: { click: toggleMenu }"></button>
                        <div class="default-logo">
                            <a onclick="window.location.assign('https://sentinelpro.com/')">
                                <img src="/assets/images/logo-black.svg" alt="Logo">
                            </a>
                        </div>
                        <nav class="default-menu" data-bind="css: { 'show': menuToggle }" id="default-menu">
                            <button class="close-menu-button icon i-close" data-bind="event: { click: toggleMenu }"></button>
                            <ul>
                                <li><a onclick="window.location.assign('https://sentinelpro.com/pages/pricing')">Pricing</a></li>
                                <li><a onclick="window.location.assign('https://sentinelpro.com/pages/contact')">Contact</a></li>
                                <li><a onclick="window.location.assign('https://sentinelpro.com/resources/faq')">FAQ</a></li>
                                <li><a onclick="window.location.assign('https://sentinelpro.com/resources/api-documentation')">Documentation</a></li>
                            </ul>
                        </nav>
                    </div>
                    <div class="default-header-right">

                        <a onclick="window.location.assign('https://sentinelpro.com/login')" class="default-link"><span>Log In</span></a>
                        <a onclick="window.location.assign('https://sentinelpro.com/pages/pricing')" class="default-button"><span>Start Now</span></a>
                    </div>
                </div>
            </header>
            `;
    }

    protected initPartial(): void {

    }

    protected getTemplateName(): string{
        return "appHeaderPromo-template";
    }

    protected getMainElementClasses(): Array<string>{
    	return ["w-justify"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return  {
            menuToggle: ko.observable(0),
            toggleMenu: function(data){

                huit_neuf_this.toggleMenu();
            },
        };
    }

    private toggleMenu(){

        this.getTemplateViewModel().menuToggle(!this.getTemplateViewModel().menuToggle());
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/appHeaderPromo_template.ts